import React from 'react';
import { useTranslation } from 'next-i18next';
import { Card, CardContent, StaticTooltip } from '@lb-service/ui';
import colors from 'tailwindcss/colors';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import TimelinePointMarker from './PointMarker';
import SectionIntro from '../../../molecules/SectionIntro';

const PricingTimeline = () => {
  const { t } = useTranslation('common');
  return (
    <div className="payment-cycle">
      <Card className="bg-slate-50 border-0 shadow-none rounded-none">
        <CardContent>
          <div className="payment-cycle-container">
            <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8 pt-24">
              <SectionIntro title={t('service.pricing.timeline.title')} />
              <div className="section-content text-center mb-24">
                <div className="timeline-container">
                  <div className="grid grid-cols-12 clear-both">
                    <div
                      className="col-span-4 h-6"
                      style={{ background: colors.cyan[400] }}
                    >
                      <div className="relative">
                        <StaticTooltip
                          title={
                            <span className="text-default text-md">
                              {t('service.pricing.timeline.freeTrial')}
                            </span>
                          }
                        >
                          <TimelinePointMarker />
                        </StaticTooltip>

                        <div className="absolute left-0 top-7">
                          <span>
                            {t('service.pricing.timeline.startAnytime')}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div
                      className="col-span-4 h-6"
                      style={{ background: colors.cyan[500] }}
                    >
                      <div className="relative">
                        <StaticTooltip
                          title={
                            <span className="text-default text-md">
                              {t('service.pricing.timeline.firstCycle')}
                            </span>
                          }
                        >
                          <TimelinePointMarker />
                        </StaticTooltip>
                        <div className="absolute left-0 top-7">
                          <span>Fri, Feb 05</span>
                        </div>
                      </div>
                    </div>
                    <div
                      className="col-span-4 h-6"
                      style={{ background: colors.cyan[600] }}
                    >
                      <div className="relative">
                        <StaticTooltip
                          title={
                            <span className="text-default text-md">
                              {t('service.pricing.timeline.secondCycle')}
                            </span>
                          }
                        >
                          <TimelinePointMarker />
                        </StaticTooltip>
                        <div className="absolute left-0 top-7">
                          <span>Thu, Mar 05</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="timeline-explanation-container">
                  <div className="grid grid-cols-12 clear-both">
                    <div className="col-span-12 md:col-span-4 pr-4">
                      <h5 className="text-lg">
                        {t('service.pricing.timeline.freeTrial')}
                      </h5>
                      <p>{t('service.pricing.timeline.freeTrialIntro')}</p>
                    </div>
                    <div className="col-span-12 md:col-span-4 pr-4">
                      <h5 className="text-lg">
                        {t('service.pricing.timeline.firstCycle')}
                      </h5>
                      <p>{t('service.pricing.timeline.firstCycleIntro')}</p>
                    </div>
                    <div className="col-span-12 md:col-span-4 pr-4">
                      <h5 className="text-lg">
                        {t('service.pricing.timeline.secondCycle')}
                      </h5>
                      <p>{t('service.pricing.timeline.secondCycleIntro')}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['common'])),
  },
});

export default PricingTimeline;
